module.exports = __webpack_public_path__ + "static/media/default-logo.2417ad78.jpg";